<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();
</script>

<template>
  <div class="slide-1-wrapper">
    <div class="t-shirt-icon"></div>
    <div class="plus-icon"></div>
    <div class="camera-icon"></div>
    <div class="question-icon"></div>
    <div class="cursor-icon"></div>
    <div class="search-icon"></div>
    <div class="image-icon"></div>
    <div class="heart-icon"></div>

    <span class="slide-text" :class="{ 'slide-text-ru': locale === 'ru' }">{{
      $t("tutorial.how_to_use_search")
    }}</span>
  </div>
</template>

<style scoped>
.slide-1-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: linear-gradient(#a5c1e8, #908fdd);
  border-radius: 40px;
  justify-content: center;
}

.t-shirt-icon {
  background-image: url("@/assets/img/imagesForTutotrial/tshirt.svg");
  background-size: 100% 100%;
  width: 21%;
  height: 23%;
  position: absolute;
  z-index: 1;
  top: 20%;
  left: -3%;
}

.plus-icon {
  background-image: url("@/assets/img/imagesForTutotrial/plus.svg");
  background-size: 100% 100%;
  width: 20%;
  height: 20%;
  position: absolute;
  z-index: 1;
  top: 12%;
  left: 20%;
}

.camera-icon {
  background-image: url("@/assets/img/imagesForTutotrial/camera.svg");
  background-size: 100% 100%;
  width: 22%;
  height: 22%;
  position: absolute;
  z-index: 3;
  top: 1%;
  left: 75%;
}

.question-icon {
  background-image: url("@/assets/img/imagesForTutotrial/question.svg");
  background-size: 100% 100%;
  width: 35%;
  height: 38%;
  position: absolute;
  z-index: 3;
  top: 20%;
  left: 41%;
}

.cursor-icon {
  background-image: url("@/assets/img/imagesForTutotrial/cursor.svg");
  background-size: 100% 100%;
  width: 24%;
  height: 26%;
  position: absolute;
  z-index: 1;
  top: 51%;
  left: 22%;
}

.search-icon {
  background-image: url("@/assets/img/imagesForTutotrial/search.svg");
  background-size: 100% 100%;
  width: 20%;
  height: 26%;
  position: absolute;
  z-index: 3;
  top: 62%;
  left: 73%;
}

.image-icon {
  background-image: url("@/assets/img/imagesForTutotrial/image.svg");
  background-size: 100% 100%;
  width: 20%;
  height: 26%;
  position: absolute;
  z-index: 3;
  top: 72%;
  left: 0%;
}

.heart-icon {
  background-image: url("@/assets/img/imagesForTutotrial/heart.svg");
  background-size: 100% 100%;
  width: 26%;
  height: 26%;
  position: absolute;
  z-index: 1;
  top: 78%;
  left: 65%;
}

.slide-text {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 7ch;
  height: 100%;
  padding-top: 40px;
  text-align: center;
  position: absolute;
  font-size: clamp(6rem, 0.7143rem + 8.2589vw, 10.625rem);
  font-weight: 600;
  line-height: 90%;
  letter-spacing: -0.04em;
  z-index: 2;
  color: var(--white-100);
  font-family: "Gilroy", sans-serif;
  letter-spacing: -2px;
}

.slide-text-ru {
  width: 6ch;
  font-size: clamp(5.9375rem, 0.5804rem + 8.3705vw, 10.625rem);
}
@media (max-width: 1024px) {
  .slide-text {
    width: 80%;
    left: 50%;
    transform: translate(-50%);
    font-size: clamp(3.75rem, 3.3796rem + 1.9753vw, 5.75rem);
  }
}
</style>
